var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { View } from '@pawgame/game-library';
import { AsyncPanel, RES, Resize } from '@pawgame/laya-game-sdk';
import { showSimpleAlert } from '../../supports/Alert';
import { showToast } from '../../supports/Toast';
import { getVersionURL } from '../../supports/getVersionURL';
import { BagPanel } from '../bag/BagPanel';
import { CodeDB } from '../game/CodeDB';
export class HomePanel extends AsyncPanel {
    constructor() {
        super('res/ui/home', 'UI_home');
    }
    doReady() {
        const _super = Object.create(null, {
            doReady: { get: () => super.doReady }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.doReady.call(this);
            this._isScene = true;
            this._isCenter = true;
            const safeY = Resize.getSafeY();
            this._skin.y = safeY;
            this._skin.setSize(Resize.getWidth(), Resize.getHeight() - safeY);
            const url = getVersionURL('res/images/scene/bg.png');
            RES.load(url).then(() => {
                this.$skin.bg.content.texture = Laya.loader.getRes(url);
            });
            for (let i = 1; i <= 6; i++) {
                const groundItem = this.$skin.dele_ground.$skin[`ground_${i}`];
                groundItem.onClick(this, this.onGroundItemClick);
            }
            this.$skin.dele_ground.$skin.ground_101.onClick(this, () => {
                View.toggle(BagPanel);
            });
            for (let i = 2; i <= 3; i++) {
                const groundItem = this.$skin.dele_ground.$skin[`ground_10${i}`];
                groundItem.onClick(this, this.onTopGroundItemClick);
            }
        });
    }
    onGroundItemClick() {
        showSimpleAlert('提示', '暂未开放');
    }
    onTopGroundItemClick() {
        showToast(CodeDB.getInst().get('1').des);
    }
}
//# sourceMappingURL=HomePanel.js.map